<div (window:resize)="onResize($event)">
    <div class="modal-header border-0 text-center" *ngIf=isDesktop>
        <button type="button" class="close" (click)="modalRef.hide()">
            <!-- <span aria-hidden="true">&times;</span> -->
        </button>
    </div>
    <div class="modal-body ui-dialog-fixed" style="padding: 14px !important">
        <div class="container-fluid">
            <kendo-pdf-export #pdf margin="2cm">
                <div class="row justify-content-between">
                    <div class="col-auto mt-3">
                        <label style="font-size:18px;  font-family: 'Panton';">{{ pageTitle | translate | labelSanitizer}}</label>

                        <div class="form-group">
                            <label>{{ 'SOP_MANAGEMENT.SOP_TITLE' | translate }}</label>
                            <p style="margin-bottom: 0px;line-height: 24px;">
                                {{layoutService.translateText(getSopTitle(), 'SOP_OBSERVATION.NONE') |
                                labelSanitizer}}
                            </p>
                        </div>
                        <div class="form-group">
                            <label>{{ 'CONFIGURE.DESCRIPTION' | translate }}</label>
                            <p style="margin-bottom: 0px;line-height: 24px;">
                                {{layoutService.translateText(getSopDescription(), 'SOP_OBSERVATION.NONE') |
                                labelSanitizer}}
                            </p>
                        </div>
                    </div>
                    <div class="col-auto pr-5 mt-3">
                        <div class="card-task">
                            <div class="card-task-media">
                                <img [ngClass]="[sopDetails.sopImage?'svg img-fluid':'no-image', sopDetails.isInstitutionImage?'imgFilter':'']"
                                    [src]="(sopDetails.sopImage)?layoutService.serverUrl+sopDetails.sopImage:'assets/ph-bhp-layout/svg/no-image-bd.png'">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sop-data-section">
                    <div class="my-4 clearfix border-top row card-strip-view sop-section">
                        <div class="col-12 px-0 example-container card-holder pt-3" #cardHolder>
                            <ng-container *ngFor="let item of sopStepsList;let i = index">
                                <div class="card card-strip d-flex col-auto pr-0" #card
                                    style="padding-left: 0px !important;">
                                    <div #cdkDragList class="col-12 p-0 d-flex">
                                        <!-- (click)="openSingleSOPUpdate(i)" -->
                                        <div class="single-sop-box m-0 card-task">
                                            <div class="card-task-media">
                                                <img [ngClass]="[(item.stepImage)?'svg img-fluid':'no-image',(item.stepCards[(item.useStepImage)?item.useStepImage:0].isInstitutionImage)?'imgFilter':'']"
                                                    [src]="(item.stepImage)?layoutService.serverUrl+item.stepImage:'assets/ph-bhp-layout/svg/no-image-bd.png'"
                                                    [class.multi-step-image-overlay]="item.stepType">
                                                <span *ngIf="item.stepType" class="multiImage"></span>
                                                <span *ngIf="!item.stepType && item.stepCards[0].handDisinfection"
                                                    class="noSterlity"></span>
                                            </div>

                                            <div class="card-task-content"
                                                [ngClass]="(!item.stepType && item.stepCards[0].hygieneRelevantStep)?'handDisinfy':'text'">
                                                <p class="card-task-desc mb-1" *ngIf="!item.stepType">
                                                    {{layoutService.translateText(item.stepCards[0].stepTittle,
                                                    'SOP_MANAGEMENT.TEXT_HERE') | labelSanitizer}}
                                                </p>
                                                <p class="card-task-desc mb-1" *ngIf="item.stepType">
                                                    {{layoutService.translateText(item.stepName,
                                                    'SOP_MANAGEMENT.TEXT_HERE')
                                                    | labelSanitizer}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template [ngIf]="item.stepType">
                                    <div class="card card-strip d-flex col-auto pr-0 mutli-step-sub-cards" #card
                                        *ngFor="let stepCards of item.stepCards;let i = index"
                                        style="padding-left: 0px !important;">

                                        <div class="col-12 p-0 d-flex">
                                            <!-- (click)="openSingleSOPUpdate(i)" -->
                                            <div class="single-sop-box m-0 card-task">
                                                <div class="card-task-media">
                                                    <img [ngClass]="[(stepCards.stepImage)?'svg img-fluid':'no-image',(stepCards.isInstitutionImage)?'imgFilter':'']"
                                                        [src]="(stepCards.stepImage)? layoutService.serverUrl+stepCards.stepImage:'assets/ph-bhp-layout/svg/no-image-bd.png'">

                                                    <span *ngIf="!item.stepType && stepCards.handDisinfection"
                                                        class="noSterlity"></span>
                                                </div>
                                                <div class="card-task-content"
                                                    [class.handDisinfy]="stepCards.hygieneRelevantStep">
                                                    <p class="card-task-desc mb-1">
                                                        {{layoutService.translateText(stepCards.stepTittle,
                                                        'SOP_MANAGEMENT.TEXT_HERE') | labelSanitizer}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>

                        </div>
                    </div>
                    <hr class="mb-0 nav-separator">
                    <div class="row data-section">
                        <div class="col-2">
                            <label>{{ 'SOP_MANAGEMENT.ACCESS' | translate }}</label>
                            <p style="margin-bottom: 0px;line-height: 24px;" *ngIf="sopDetails.accessType == 'Global'">
                                {{ 'SOP_MANAGEMENT.GLOBAL' | translate }}
                            </p>
                            <p style="margin-bottom: 0px;line-height: 24px;" *ngIf="sopDetails.accessType == 'Country'">
                                {{(institutionList && institutionList.length > 0)? ('SOP_MANAGEMENT.INSTITUTION' |
                                translate):('AUTHORIZATION.COUNTRY' | translate) }}
                            </p>
                        </div>
                        <div class="col-2">
                            <label>{{ 'DASHBOARD.INSITITUTIONS' | translate }}</label>
                            <div *ngIf="sopDetails.accessType == 'Country' && countriesList.length > 0">
                                <div *ngFor="let data of newList">
                                    <span>{{data.countryName | translate | labelSanitizer}}</span>
                                    <div class="mb-2" *ngFor='let institution of data.institutionList'>
                                        <p style="margin-bottom: 0px;line-height: 24px;">
                                            {{institution.institutionName | labelSanitizer}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="sopDetails.accessType == 'Country' && institutionList.length > 0">
                                <div *ngFor='let data of institutionList'>
                                    <p style="margin-bottom: 0px; line-height: 24px;"
                                        *ngIf="institutionChecked[data.institution.institution.institutionID]">
                                        {{data.institution.institution.institutionName | labelSanitizer}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row data-section">
                        <div class="col-4">
                            <label>{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</label>
                            <div>
                                <p style="margin-bottom: 0px;line-height: 24px;">
                                    {{layoutService.translateText(sopDetails.draftComments, 'SOP_OBSERVATION.NONE') |
                                    labelSanitizer}}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </kendo-pdf-export>
            <div class="download-section justify-content-end">
                <button type="button" class="btn btn-outline-primary my-2 mx-3 pl-4 pr-4 align-items-center download-button"
                    (click)="layoutService.showLoader = true;callTimeoutDownload()">
                    <img class="mr-2" src="assets/icons/downloadOutlined.svg" />
                    <span class="deskButton">{{ 'EVALUATION.DOWNLOAD_PDF' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
